module.exports = __webpack_public_path__ + "static/media/sa-cavalcante-menu.aa6ee177.png";